import React from 'react';
import Modal from "react-bootstrap/Modal";
import { withRouter } from 'react-router';
// import moment from 'moment';
import { ErrorBlock } from '../../../hoc/FormInput';
import {isSet} from '../../../Utils/CommonFunctions';
import FormInputFields from '../../../Components/FormInputFields';

const CreateNew = (props) => {
    const curState = props.curState;
    const fields = curState.new_fields;
    const rateSheets = curState.rateSheets;
    const serviceList = curState.serviceList;
    const rateConfigList = curState.referenceConfigOptions;
    const violations = curState.violations;
    const apiListOptions = curState.apiListOptions;
    const auotmationListOptions = curState.auotmationListOptions;

    let options = [];
    rateSheets.map((arr,i) => {
        const value = {
          "value": arr.id,
          "label": arr.name,
        }
        options.push(value);
    });
    
    const onChangeHandler = (key,value,fieldName)=>{
        props.valueUpdateHandler(key,value,fieldName);
    }
    const formFields = [{
        type:'TextInput',
        label:'Name',
        value:fields.name,
        fieldName:'name',
        changeHandler:(val)=>onChangeHandler('name',val,'name'),
        attributes:{
            className:'form-control mandatory'
        }
    },
    {
        type:'DateTime',
        label:'Start On',
        fieldName:'startDate',
        value:fields.start_on,//moment(fields.start_on).format('YYYY-MM-DDTHH:mm'),
        changeHandler:(val)=>onChangeHandler('start_on',val,'startDate'),
        attributes:{
            getDateFormat:'YYYY-MM-DD HH:mm:ss',
            putDateFormat:'YYYY-MM-DD HH:mm:ss',
            className:'form-control mandatory'
        }
    },
    {
        type:'DateTime',
        label:'Expired On',
        fieldName:'endDate',
        value:fields.expires_on,//moment(fields.expires_on).format('YYYY-MM-DDTHH:mm'),
        changeHandler:(val)=>onChangeHandler('expires_on',val,'endDate'),
        attributes:{
            getDateFormat:'YYYY-MM-DD HH:mm:ss',
            putDateFormat:'YYYY-MM-DD HH:mm:ss',
            className:'form-control mandatory'
        }
    },
    /*{
        type:'PickList',
        label:'Service',
        required:true,
        value:fields.service,
        fieldName:'serviceId',
        options:serviceList.map((itm)=>{
            return{
                id:itm.key,
                value:itm.value,
                label:itm.value
            }
        }),
        changeHandler:(val)=>onChangeHandler('service',val,'serviceId'),
        attributes:{className:'form-control mandatory'}
    },*/
    {
        type:'PickList',
        label:'Type',
        value:fields.type,
        required:true,
        fieldName:'rate_type',
        options:['LOCAL','API','AUTOMATION','ALL'].map((itm)=>{
            return{
                id:itm,
                value:itm,
                label:itm
            }
        }),
        changeHandler:(val)=>onChangeHandler('type',val,'rate_type'),
        attributes:{}
    },
    {
        type:'MultiSelect',
        label:'Automation',
        value:fields.rate_config_automations,   
        fieldName:'rate_config_automations',
        options:auotmationListOptions,
        access_mode:(fields.type==='ALL' || fields.type==='AUTOMATION')?true:false,
        changeHandler:(val)=>onChangeHandler('rate_config_automations',(val===null)?[]:val,'rate_config_automations'),
        attributes:{}
    },
    {
        type:'MultiSelect',
        label:'API',
        value:fields.rate_configuration_apis,   
        fieldName:'rate_configuration_apis',
        options:apiListOptions,
        access_mode:(fields.type==='ALL' || fields.type==='API')?true:false,
        changeHandler:(val)=>onChangeHandler('rate_configuration_apis',(val===null)?[]:val,'rate_configuration_apis'),
        attributes:{}
    },
    {
        type:'MultiSelect',
        label:'Sheet',
        value:fields.rate_sheet,   
        fieldName:'rateSheetIds',
        options:options,
        access_mode:(fields.type==='ALL' || fields.type==='LOCAL')?true:false,
        changeHandler:(val)=>onChangeHandler('rate_sheet',(val===null)?[]:val,'rateSheetIds'),
        attributes:{}
    },{
        type:'PickList',
        label:'Reference Config',
        value:fields.reference_rateconfig_id,
        fieldName:'reference_rateconfig_id',
        options:rateConfigList.map((itm)=>{
            return{
                id:itm.id,
                value:itm.name,
                label:itm.name
            }
        }),
        changeHandler:(val)=>onChangeHandler('reference_rateconfig_id',val,'reference_rateconfig_id'),
        attributes:{}
    },
    {
        type:'OnAndOffField',
        label:'Active',
        value:fields.active,
        fieldName:'active',
        changeHandler:(val)=>onChangeHandler('active',val,'active'),
        attributes:{
            id:'isActive',
            name:'isActive'
        }
    },
    {
        type:'TextArea',
        label:'Description',
        colSize:'col-12',
        value:fields.description,
        fieldName:'description',
        changeHandler:(val)=>onChangeHandler('description',val,'description'),
        attributes:{}
    }]
    return (
		<Modal size="lg" show={props.modelOpen} >
            <Modal.Header>
                <h5 className="modal-title secondary_color pl-2">Rates Configuration </h5>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    {formFields.map((item,itemIndex)=>{
                        if(isSet(item.access_mode,true)===false){return false;}
                        const appendClass = (isSet(violations[item.fieldName],null)!==null)?'has-error':'';
                        return(
                            <div className={`${isSet(item.colSize,'col-6')} ${appendClass}`} key={itemIndex}>
                                <div className="form-group">
                                    <label> {item.label} </label>
                                    <FormInputFields {...item}/>
                                    <ErrorBlock message={isSet(violations[item.fieldName],'')}/>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </Modal.Body>

            <Modal.Footer> 
                <a onClick={props.toggleModel} className="btn btn-cancel" data-dismiss="modal"> Cancel </a> 
                <a onClick={props.saveHandler} className="btn primary_bg" data-dismiss="modal"> Save </a>                  
            </Modal.Footer>
		</Modal>
	);
}

export default withRouter(CreateNew);